import './styles.css'

import start from '@/mains/common.js'

import formatters from './formatters.js'

import idbEntities from './idb.js'

import { menuOptions } from './menu.js'

import routes from './routes.js'

import vars from './theme-vars.js'

start(import('./store.js'), routes, formatters, menuOptions, idbEntities, vars, 'Trenton Agri-Products')
